import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import { Theme } from '@app/theme';
import { QuotaRef, Session } from '@app/api';
import { SessionBoxColumn } from './SessionBoxColumn';

const useStyles = createUseStyles((theme: Theme) => ({
  wrapper: {
    flex: 1,
    position: 'relative',
    width: '100vw',
  },
  container: {
    ...theme.absoluteFill,
    backgroundColor: theme.colors.grayBackground,
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
  containerScrollHorizontal: {
    overflowX: 'auto',
  },
  overviewContainer: {
    background: theme.colors.white,
    minWidth: 304,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: [
      [
        theme.marginBase * 4,
        theme.marginBase * 3,
        theme.marginBase * 4,
        theme.marginBase * 5,
      ],
    ],
    height: '100%',
  },
  content: {
    width: '100%',
    position: 'relative',
    overflowY: 'auto',
    height: '100%',
    flexShrink: 1,
    padding: [[theme.marginBase * 4, theme.marginBase * 3]],
    [theme.media.tablet]: {
      paddingLeft: theme.marginBase * 3,
      paddingRight: theme.marginBase * 3,
    },
    [theme.media.mobile]: {
      paddingLeft: theme.marginBase,
      paddingRight: theme.marginBase,
    },
  },
  horizontalScrollContent: {
    width: 'max-content',
    flexShrink: 0,
  },
}));

interface Props {
  session: Session;
  horizontalScroll?: boolean;
  children?: React.ReactNode;
  contentClassName?: string;
  taggedCriteria?: string[];
  onAddQuotaItemTag?: (criterion: QuotaRef) => any;
  onRemoveQuotaItemTag?: (criterion: QuotaRef) => any;
}

export const WithOverviewColumnLayout = ({
  session,
  horizontalScroll,
  children,
  contentClassName,
  taggedCriteria,
  onAddQuotaItemTag,
  onRemoveQuotaItemTag,
}: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <div
        className={classNames(classes.container, {
          [classes.containerScrollHorizontal]: !!horizontalScroll,
        })}
      >
        <div className={classes.overviewContainer}>
          <SessionBoxColumn
            session={session}
            taggedCriteria={taggedCriteria}
            onAddQuotaItemTag={onAddQuotaItemTag}
            onRemoveQuotaItemTag={onRemoveQuotaItemTag}
          />
        </div>
        <div
          className={classNames(classes.content, contentClassName, {
            [classes.horizontalScrollContent]: !!horizontalScroll,
          })}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
